<app-spinner [isLoading]="isLoading$ | async">
  @if ( { announcementDetails: announcementDetails$ | async,
  announcementNotFound: announcementNotFound$ | async, similarAnnouncements:
  similarAnnouncementList$ | async, favoriteAnnouncementsMap:
  favoriteAnnouncementsMap$ | async, socialMediaShareLinks:
  socialMediaShareLinks$ | async, timeZone: timeZone$ | async, topBanner:
  topBanner$ | async, rightBanner: rightBanner$ | async, rightBanner2:
  rightBanner2$ | async, rightBanner3: rightBanner3$ | async, rightBannerSquare:
  rightBannerSquare$ | async, middleBanner: middleBanner$ | async, bottomBanner:
  bottomBanner$ | async, isJobseekerSignedIn: isJobseekerSignedIn$ | async,
  isCustomerSignedIn: isCustomerSignedIn$ | async, isJobseekerInvited:
  isJobseekerInvited$ | async, announcementInvitedJobseeker:
  announcementInvitedJobseeker$ | async, isSignedIn: isSignedIn$ | async, user:
  user$ | async, isAnnouncementLinkCopied: isAnnouncementLinkCopied$ | async,
  isLoading: isLoading$ | async, announcementViewStats: announcementViewStats$ |
  async, isCvBoxSliderVisible: isCvBoxSliderVisible$ | async, desktopImage:
  desktopImage$ | async, mobileImage: mobileImage$ | async, ownAnnouncements:
  ownAnnouncements$ | async, currency: currency$ | async, currentLanguage:
  currentLanguage$ | async, previousAnnouncementId: previousAnnouncementId$ |
  async, nextAnnouncementId: nextAnnouncementId$ | async, userType: userType$ |
  async }; as data ) {
  <!-- `branded` drives the light-on-dark text treatment used when a customer
         supplies its own announcement background colour. -->
  @let branded = data.announcementDetails?.isWithBranding &&
  data.announcementDetails?.customerBranding?.announcementDetailsBgColor !=
  null; @let coverImage = targetId === target.Responsive ? data.mobileImage :
  data.desktopImage;

  <div
    class="page"
    [ngClass]="{ 'page--branded': !data.isLoading && branded }"
    [ngStyle]="
      !data.isLoading && branded
        ? {
            background:
              data.announcementDetails.customerBranding
                ?.announcementDetailsBgColor
          }
        : {}
    "
  >
    <div class="page__inner">
      @if ( data.announcementDetails != null && !data.isLoading &&
      !data.announcementDetails?.expired && !data.announcementNotFound ) {
      <!--Banner Top-->
      <div class="banner banner--top">
        <app-banner
          [banner]="data.topBanner"
          [pageId]="pageId.AnnouncementDetailsPage"
        ></app-banner>
      </div>

      <div class="layout">
        <div class="layout__main">
          <!--Back / previous / next-->
          <div class="toolbar">
            <a
              [routerLink]="routerLink$ | async"
              [queryParams]="queryParams$ | async"
              class="nav-button nav-button--back"
            >
              <svg-icon
                class="nav-button__icon"
                src="/assets/icons/chevron-left-green.svg"
                [svgClass]="'chevron'"
              ></svg-icon>
              <span class="nav-button__text">
                {{ 'label.BackToSearchResults' | translate }}
              </span>
            </a>

            <div class="toolbar__pager">
              @if (data.previousAnnouncementId != null) {
              <a
                [routerLink]="[
                  '/announcement',
                  data.previousAnnouncementId.announcementId,
                  translit.getUrlFriendlyString(
                    data.previousAnnouncementId.announcementTitle
                  )
                ]"
                [queryParams]="{ nav: 1 }"
                class="nav-button"
              >
                <svg-icon
                  class="nav-button__icon"
                  src="/assets/icons/chevron-left-green.svg"
                  [svgClass]="'chevron'"
                ></svg-icon>
                <span class="nav-button__text">
                  {{ 'label.previous' | translate }}
                </span>
              </a>
              } @else {
              <div class="nav-button nav-button--disabled">
                <svg-icon
                  class="nav-button__icon"
                  src="/assets/icons/chevron-left-green.svg"
                  [svgClass]="'chevron'"
                ></svg-icon>
                <span class="nav-button__text">
                  {{ 'label.previous' | translate }}
                </span>
              </div>
              } @if (data.nextAnnouncementId != null) {
              <a
                [routerLink]="[
                  '/announcement',
                  data.nextAnnouncementId.announcementId,
                  translit.getUrlFriendlyString(
                    data.nextAnnouncementId.announcementTitle
                  )
                ]"
                [queryParams]="{ nav: 1 }"
                class="nav-button"
              >
                <span class="nav-button__text">
                  {{ 'label.Next' | translate }}
                </span>
                <svg-icon
                  class="nav-button__icon"
                  src="/assets/icons/chevron-right-green.svg"
                  [svgClass]="'chevron'"
                ></svg-icon>
              </a>
              } @else {
              <div class="nav-button nav-button--disabled">
                <span class="nav-button__text">
                  {{ 'label.Next' | translate }}
                </span>
                <svg-icon
                  class="nav-button__icon"
                  src="/assets/icons/chevron-right-green.svg"
                  [svgClass]="'chevron'"
                ></svg-icon>
              </div>
              }
            </div>
          </div>

          <!--
                Announcement details. The customer branding cover and logo are
                projected into the tile's summary card, so they share its
                surface without the tile having to know the page's store.
              -->
          <hrra-announcement-details-tile
            [announcementDetails]="data.announcementDetails"
            [publishDate]="publishDate$ | async"
            [timeZone]="data.timeZone"
            [currentLanguage]="data.currentLanguage"
            [currentUserType]="data.userType"
            [user]="data.user"
            [isSignedIn]="data.isSignedIn"
            [isJobseekerSignedIn]="data.isJobseekerSignedIn"
            [isJobseekerInvited]="data.isJobseekerInvited"
            [announcementInvitedJobseeker]="data.announcementInvitedJobseeker"
            [showInviteResponse]="data.isJobseekerInvited === true"
            [isPublicView]="true"
            [isFavorite]="
              data.favoriteAnnouncementsMap[
                data.announcementDetails?.announcementId
              ] === true
            "
            [isAnnouncementLinkCopied]="data.isAnnouncementLinkCopied"
            [socialMediaShareLinks]="data.socialMediaShareLinks"
            [providerWebsiteId]="providerWebsiteId"
            (cvSend)="
              onCvSend($event, data.isSignedIn, data.isJobseekerSignedIn)
            "
            (toggleFavorite)="
              onToggleFavorite(data.announcementDetails?.announcementId, $event)
            "
            (externalApply)="
              redirectToUrl(
                data.isJobseekerSignedIn,
                data.announcementDetails?.hasCaptureCv,
                $event
              )
            "
            (copyLink)="copyCurrentRoute()"
            (socialShare)="shareOnSocialMedia($event)"
            (inviteRespond)="onInviteRespond($event)"
          >
            <!--
                    Projected slots are matched against the static template, so
                    these two stay in the DOM and hide themselves instead of
                    sitting behind a control-flow block.
                  -->
            <div
              annCover
              class="branding-cover"
              [class.branding-cover--empty]="coverImage == null"
              [ngStyle]="
                coverImage != null
                  ? { 'background-image': 'url(' + coverImage + ')' }
                  : {}
              "
            ></div>

            <div
              annLogo
              class="branding-logo"
              [class.branding-logo--empty]="!data.announcementDetails?.hasLogo"
            >
              <img
                class="branding-logo__img"
                [attr.src]="
                  data.announcementDetails?.hasLogo
                    ? data.announcementDetails?.logoUrl
                    : null
                "
                alt=""
              />
            </div>
          </hrra-announcement-details-tile>

          <!--
            Specialization navigation - disabled for now. The details tile
            already lists the specializations, and the redesign has no place
            for a second, clickable copy of them. Styles for it are kept in
            the stylesheet so this can be switched back on as-is.

          @if ( data.announcementDetails?.announcementRequirements
          ?.specializationList?.length > 0 ) {
          <div class="categories">
            @for ( headSpecialization of data.announcementDetails
            ?.announcementRequirements?.specializationList; track $index ) {
            <div class="categories__group">
              <span
                (click)="onSpecializationClick(headSpecialization.code)"
                class="categories__head"
              >
                {{ headSpecialization.name }}
              </span>
              <svg-icon
                class="categories__icon"
                src="/assets/icons/chevron-right-green.svg"
                [svgClass]="'chevron'"
              ></svg-icon>
              <span class="categories__children">
                @for ( specialization of headSpecialization.children; track
                $index; let last = $last ) {
                <span
                  (click)="onSpecializationClick(specialization.code)"
                  class="categories__child"
                >
                  {{ specialization.name }}{{ last ? '' : ',' }}
                </span>
                }
              </span>
            </div>
            }
          </div>
          }
          -->

          <!--View statistics-->
          <div class="stats">
            <div class="stats__item">
              <svg-icon
                class="stats__icon"
                src="/assets/icons/views.svg"
              ></svg-icon>
              <span class="stats__label">
                {{ 'label.Views' | translate }}
              </span>
              <span class="stats__value">
                {{
                  data.announcementViewStats?.totalViewsOnWebsite !== null
                    ? data.announcementViewStats.totalViewsOnWebsite
                    : ''
                }}
              </span>
            </div>

            <div class="stats__item">
              <svg-icon
                class="stats__icon"
                src="/assets/icons/unique-views.svg"
              ></svg-icon>
              <span class="stats__label">
                {{ 'label.UniqueViews' | translate }}
              </span>
              <span class="stats__value">
                {{
                  data.announcementViewStats?.uniqueViewsOnWebsite !== null
                    ? data.announcementViewStats?.uniqueViewsOnWebsite
                    : ''
                }}
              </span>
            </div>

            @if ( data.announcementDetails?.applicationMethod ==
            applicationMethod.ViaWebsite ) {
            <div class="stats__item">
              <svg-icon
                class="stats__icon"
                src="/assets/icons/sent-cvs.svg"
              ></svg-icon>
              <span class="stats__label">
                {{ 'label.SentCvs' | translate }}
              </span>
              <span class="stats__value">
                {{ data.announcementDetails?.totalApplicationsOnWebsite }}
              </span>
            </div>
            }
          </div>

          <!--Banner middle-->
          <div class="banner banner--middle">
            <app-banner
              [banner]="data.middleBanner"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
        </div>

        <aside class="layout__side">
          <!--Banner right. Empty slots are skipped so they leave no gap.-->
          @if (data.rightBanner3) {
          <div class="banner banner--side">
            <app-banner
              [banner]="data.rightBanner3"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
          } @if (data.rightBanner) {
          <div class="banner banner--side">
            <app-banner [banner]="data.rightBanner"></app-banner>
          </div>
          } @if (data.rightBanner2) {
          <div class="banner banner--side">
            <app-banner
              [banner]="data.rightBanner2"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
          }

          <!--own announcements-->
          @if ( data.announcementDetails?.isWithBranding &&
          data.announcementDetails?.customerBranding
          .announcementDetailsDisplayOtherAnnouncements &&
          data.ownAnnouncements.length > 0 ) {
          <section class="side-card ann-list">
            <h3 class="side-card__title">
              {{ 'label.OwnAnnouncements' | translate }}
            </h3>

            @for ( ownAnnouncement of data.ownAnnouncements; track
            ownAnnouncement.announcementId ) {
            <div class="ann-list__item">
              <app-similar-ann-item
                [similarAnnouncement]="ownAnnouncement"
              ></app-similar-ann-item>
            </div>
            }
          </section>
          }

          <!--Cv Box-->
          @if ( data.announcementDetails?.isWithBranding &&
          data.announcementDetails.isWithCvBox ) {
          <section class="cv-box">
            <div class="cv-box__header">
              <div class="cv-box__text">
                {{ 'label.LeaveYourCvToCompanies' | translate }}
              </div>
              <h2 class="cv-box__title">
                {{ 'label.InCvBox' | translate }}
              </h2>
            </div>

            <app-cv-box-item
              class="cv-box__box"
              [cvBox]="data.announcementDetails.customerCvBox"
              [userType]="data.userType"
            ></app-cv-box-item>
          </section>
          } @if (data.similarAnnouncements?.length > 0) {
          <section class="side-card ann-list">
            <h3 class="side-card__title">
              {{ 'label.SimilarAnnouncements' | translate }}
            </h3>

            @for ( similarAnnouncement of data.similarAnnouncements; track
            similarAnnouncement.announcementId ) {
            <div class="ann-list__item">
              <app-similar-ann-item
                [similarAnnouncement]="similarAnnouncement"
              ></app-similar-ann-item>
            </div>
            }
          </section>
          }

          <!--Banner right -->
          @if (data.rightBannerSquare) {
          <div class="banner banner--side">
            <app-banner
              [banner]="data.rightBannerSquare"
              [pageId]="pageId.AnnouncementDetailsPage"
            ></app-banner>
          </div>
          }
        </aside>
      </div>

      @if (data.isCvBoxSliderVisible) {
      <div class="cv-box-slider">
        <owl-carousel-o [options]="cvBoxSliderOptions" class="carousel">
          @for (cvBox of cvBoxes$ | async; track cvBox.customerId) {
          <ng-container>
            <ng-template carouselSlide [id]="cvBox.customerId">
              <app-cv-box-item
                ngxSlickItem
                [cvBox]="cvBox"
                class="cv-box-slider__item"
                [userType]="userType$ | async"
              ></app-cv-box-item>
            </ng-template>
          </ng-container>
          }
        </owl-carousel-o>
      </div>
      }

      <!--Banner bottom-->
      <div class="banner banner--bottom">
        <app-banner
          [banner]="data.bottomBanner"
          [pageId]="pageId.AnnouncementDetailsPage"
        ></app-banner>
      </div>
      } @if (data.announcementNotFound || data.announcementDetails?.expired) {
      <div class="unavailable">
        <app-not-existing-page
          [errorType]="errorType.NotAvailable"
          [hideDefaultMessage]="true"
        ></app-not-existing-page>

        <h4 class="unavailable__title">
          {{ 'message.AnnouncementExpiredOrDoesNotExist' | translate }}
        </h4>

        @if (data.similarAnnouncements?.length > 0) {
        <div class="unavailable__suggestions">
          <h4 class="unavailable__suggestions-title">
            {{ 'label.YouMayInterest' | translate }}:
          </h4>

          <div class="expired-ann-list">
            @for ( announcement of data.similarAnnouncements; track
            announcement.announcementId ) {
            <div class="expired-ann">
              <div class="expired-ann__title">
                <a
                  class="expired-ann__title-link"
                  [routerLink]="['/announcement', announcement?.announcementId]"
                  >{{ announcement?.title }}</a
                >
              </div>
              <div class="expired-ann__company-name">
                {{ announcement?.customerName }}
              </div>
              <div class="expired-ann__dates">
                {{
                  announcement?.publishDate
                    | date: 'dd MMM':data.timeZone:data.currentLanguage
                }}
                -
                {{
                  announcement?.deadlineDate
                    | date: 'dd MMM':data.timeZone:data.currentLanguage
                }}
              </div>
            </div>
            }
          </div>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }
</app-spinner>
